export default __webpack_public_path__ + "static/media/signup.c25b859b.png";